import { IConfig } from "./Render";
export const Text = ({className, id, style, children, extraProps}:IConfig)=>
{   
    return (<text id={id} transform = { extraProps.transform } className = { className }  
           x={extraProps.x} y={extraProps.y} fontWeight={extraProps.fontWeight}
           fontStyle={extraProps.fontStyle} fontSize= {extraProps.fontSize}
           textDecoration= {extraProps.textDecoration} textAnchor={extraProps.textAnchor} stroke={extraProps.stroke}> {children} </text>      
);
}